import React from "react";
import { TileLayer } from "react-leaflet";

export const MAIN_COLOR = "#E28020";
export const DANGER_COLOR = "#dc3545";

export const MAPBOX_ACCESSTOKEN = "pk.eyJ1IjoibmV4Y28tY2VudHJhbC0wMSIsImEiOiJjbHh0eDVsOGUyM25tMnNxcnlhd29iMHlnIn0.hKdn8x23Y6-2R8xzkY3Nyg"

/**
 * Surface Typeフィルタ定義
 * MEMO: Distressの色分けルールと同様、最終的にDBに登録して参照する形になると思われる
 */
export const SURFACE_TYPES = [
  {
    title: "APC",
    description: "APC: Asphaltic Concrete",
    color: "#019352"
  },
  {
    title: "AAC",
    description: "AAC: Autoclaved aerated Concrete",
    color: "#DBE56A"
  },
  {
    title: "AC",
    description: "AC: Asphalt Concrete",
    color: "#FFC000"
  },
  {
    title: "PCC",
    description: "PCC: Portland Cement Concrete",
    color: "#FF7D31"
  },
  {
    title: "BR",
    description: "BR: Block Road? ",
    color: "#FF0000"
  },
  {
    title: "GR",
    description: "GR: Gravel Road?",
    color: "#E28020"
  }
];

// Layer ID定義(GIS画面、Road Surveyed Listの画面想定)
export const LAYER_IDS = {
  POINT: "point",
  LINE: "line",
  LINE_LABEL: "line_label"
};
// Source ID定義(GIS画面、Road Surveyed Listの画面想定)
export const SOURCE_IDS = {
  POINT: "point",
  LINE: "line"
};

/**
 * Survey Type （CSV取込時の方式）
 */
export const SURVEY_TYPE = {
  SPM_PASER: {
    label: "SPM-PASER",
    value: "0"
  },
  SPM_PCI: {
    label: "SPM-PCI",
    value: "1",
  },
  SPM_PCI_DP: {
    label: "SPM-PCI + DP",
    value: "2"
  }
}

// export const DeteriorationRankList = [
//   { title: "1 &nbsp; &nbsp; Excellent", value: [1], color: "#019352" },
//   { title: "2 &nbsp; &nbsp; Very Good", value: [2], color: "#DBE56A" },
//   { title: "3 &nbsp; &nbsp; Good", value: [3], color: "#FFC000" },
//   { title: "4 &nbsp; &nbsp; Fair", value: [4], color: "#FF7D31" },
//   { title: "5 &nbsp; &nbsp; Poor", value: [5], color: "#FF0000" },
// ];

export const BaseMapTile = () => (
  <TileLayer
    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
    id="mapbox.light"
  />
);

export const MenuType = {
  // Dashboard: { label: "Dashboard", value: 1 },
  GIS: { label: "GIS", value: 2 },
  SurveyedList: { label: "Road Surveyed List", value: 3 },
  RoadInfoList: { label: "Road Information List", value: 4 },
  ManageUsers: { label: "Manage Users", value: 5 },
  SurfaceCondition: { label: "Manage Surface", value: 6 },
  Settings: { label: "Settings", value: 7 },
};

export const PermissionType = {
  View: {
    value: 1,
    name: "View",
  },
  Add: {
    value: 2,
    name: "Add",
  },
  Edit: {
    value: 3,
    name: "Edit",
  },
  Delete: {
    value: 4,
    name: "Delete",
  },
  Upload: {
    value: 5,
    name: "Upload",
  },
  Download: {
    value: 6,
    name: "Download",
  },
  AccessPeriod: {
    value: 7,
    name: "AccessPeriod",
  },
  SwitchImages: {
    value: 8,
    name: "SwitchImages",
  },
};

export const UserRole = {
  Admin: {
    value: 1,
    name: "Admin",
  },
  User: {
    value: 2,
    name: "User",
  },
};
